export default __webpack_public_path__ + "static/media/HERMES.aa4694ea.svg";